<template>
  <ui-modal v-model="isOpen" :header-title="$t('birthday_setting_confirm_save')" :forcing="true" @close-icon-event="handleBack">
    <p class="!wd-mb-0 wd-p-5 wd-text-omd wd-text-black50">
      {{ $t('birthday_setting_confirm_date_warning', { date }) }}
    </p>
    <template #buttons>
      <div class="wd-flex wd-px-5 wd-py-3 wd-gap-3 xs:wd-py-3.5 xs:wd-gap-2 xs:wd-justify-end">
        <v-btn
          class="wd-text-otempmd wd-flex-1 xs:wd-flex-none"
          :height="40"
          :color="isMobile ? 'gray20' : undefined"
          variant="flat"
          @click="handleBack"
        >
          {{ $t('all_back') }}
        </v-btn>
        <v-btn
          class="wd-text-otempmd wd-flex-1 xs:wd-flex-none"
          :height="40"
          color="orange50"
          variant="flat"
          :loading="loading"
          @click="handleConfirm"
        >
          {{ isMobile ? $t('confirm_change_modal_save_button') : $t('all_ok') }}
        </v-btn>
      </div>
    </template>
  </ui-modal>
</template>

<script setup lang="ts">
import UiModal from '@/components/dialog/ui-modal.vue'

import { useBreakpoints } from '@/composition/useBreakpoints'

interface Props {
  date: string
  loading?: boolean
}

defineProps<Props>()

const emit = defineEmits<{
  back: []
  confirm: []
}>()

const isOpen = defineModel<boolean>({ default: false })
const { isMobile } = useBreakpoints()

function handleBack() {
  emit('back')
}

function handleConfirm() {
  emit('confirm')
}
</script>
